import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  FormControlLabel,
  Stack,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

type Props = {
  isFormDisabled: boolean;
  displayOnBookingDirectory: boolean;
  handleCheckBoxStateChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  forcePrivateListing?: boolean;
  showBookingDirectoryToggle?: boolean;
};

export default function BookingBusinessSettingsForm({
  isFormDisabled,
  displayOnBookingDirectory,
  handleCheckBoxStateChange,
  forcePrivateListing = false,
  showBookingDirectoryToggle = true,
}: Props): JSX.Element {
  if (!showBookingDirectoryToggle) return <></>;

  return (
    <Stack spacing={4} sx={{ mt: 4 }}>
      <Accordion defaultExpanded sx={{ borderRadius: 2 }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6">Visibility</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Stack spacing={2}>
            {showBookingDirectoryToggle ? (
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isFormDisabled}
                    name="displayOnBookingDirectory"
                    checked={!!displayOnBookingDirectory}
                    onChange={handleCheckBoxStateChange}
                  />
                }
                label="Show on Timely365 Booking directory"
              />
            ) : null}
            <Typography variant="body2" color="text.secondary">
              Choose whether customers can find this business in the Timely365 booking directory.
            </Typography>
          </Stack>
        </AccordionDetails>
      </Accordion>
    </Stack>
  );
}
